import type { IconSvgObject } from './types';

const SoftwareLicenseIcon: IconSvgObject = [
  ["path", { d: "M18 20H19C20.1046 20 21 19.1046 21 18V4C21 2.89543 20.1046 2 19 2H5C3.89543 2 3 2.89543 3 4V18C3 19.1046 3.89543 20 5 20H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 7H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 11C13.6569 11 15 12.3431 15 14C15 15.6569 13.6569 17 12 17C10.3431 17 9 15.6569 9 14C9 12.3431 10.3431 11 12 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 16.5V22L12 20.5L10 22V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default SoftwareLicenseIcon;
